import React from 'react'
import { PromotionPositionContext } from '@scentregroup/shared/context'
import ParkingModules from '@scentregroup/shared/components/parking-modules'
import { Box } from '@hub/box'
import { SGPageTemplateWithAdZones } from '../../../../../src/types/page-templates'
import { CentreTradingHours } from '../../../../../src/shared/helpers/parse-opening-hours/types'
import { ContentDetail } from '../../../lib/get-content-detail'
import { Centre } from '../../../lib/get-centre-by-slug'
import { Template } from '@scentregroup/shared/components/page-templates/template'

interface IParkingContentDetailProps {
  centre: Centre
  content: ContentDetail['parking']
  template: SGPageTemplateWithAdZones
  centreTradingHours: CentreTradingHours
}

export const ParkingContentDetail = ({
  centre,
  content: parking,
  template,
  centreTradingHours,
}: IParkingContentDetailProps): JSX.Element => (
  <PromotionPositionContext.Provider
    value={parking.analyticsMetadata?.displayId ?? undefined}
  >
    <ParkingModules
      centre={centre}
      centreTradingHours={centreTradingHours}
      modules={parking.modulesCollection?.items || []}
    />

    <Box
      sx={{
        marginTop: ['spacing-lg', 'spacing-2xl'],
      }}
    >
      <Template template={template} />
    </Box>
  </PromotionPositionContext.Provider>
)
